module.exports = __webpack_public_path__ + "static/media/ScarySound.b9abce38.mp3";